// ============================= Announcement Bar Css
 var swiperannu = new Swiper(".announcement_blocks", {
  spaceBetween: 30,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

document.addEventListener("DOMContentLoaded", function () {
  // Handle click for main_cs_menu
  document.querySelectorAll(".main_cs_menu").forEach(function (menu) {
    menu.addEventListener("click", function () {
      const mainMenu = this.closest(".main_menu_cs");
      const submenu = mainMenu.querySelector(".new_sub_main");
      submenu.classList.toggle("active");
      mainMenu.classList.toggle("active");
    });
  });

  // Handle click for submenu-link
  document.querySelectorAll(".submenu-link").forEach(function (link) {
    link.addEventListener("click", function () {
      const submenuItem = this.closest(".submenu-item");
      const subSubmenu = submenuItem.querySelector(".sub-submenu");

      // Close all other active submenus
      document
        .querySelectorAll(".submenu-item.active")
        .forEach(function (activeItem) {
          if (activeItem !== submenuItem) {
            activeItem.classList.remove("active");
            activeItem.querySelector(".sub-submenu").classList.remove("active");
          }
        });

      // Toggle the clicked submenu
      submenuItem.classList.toggle("active");
      subSubmenu.classList.toggle("active");
    });
  });
});

// ============================ Mega Menu Js

  document.addEventListener('DOMContentLoaded', function () {
    const childLinks = document.querySelectorAll('[data-toggle="grandchild"]');
    const grandchildGroups = document.querySelectorAll('.grandchild-group');

    function openMenuByIndex(index) {
      grandchildGroups.forEach(group => group.style.display = 'none');
      document.querySelectorAll('.child-link').forEach(item => item.classList.remove('active'));

      const target = document.querySelector('.grandchild-group[data-index="' + index + '"]');
      const activeChild = document.querySelector('.child-link[data-index="' + index + '"]');

      if (target) target.style.display = 'block';
      if (activeChild) activeChild.classList.add('active');
    }

    if (childLinks.length > 0) {
      const firstIndex = childLinks[0].closest('.child-link').getAttribute('data-index');
      openMenuByIndex(firstIndex);
    }

    childLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent navigation
        const index = link.closest('.child-link').getAttribute('data-index');
        openMenuByIndex(index);
      });
    });
  });

// ========================= Top Main Menu

document.addEventListener('DOMContentLoaded', function () {
  const megaMenus = document.querySelectorAll('.mega-menu');
  megaMenus.forEach(menu => {
    const headerItem = menu.querySelector('.header__menu-item');
    const content = menu.querySelector('.mega-menu__content');
    function openMenu() {
      // Add active state
      menu.classList.add('active_mega_menu');
      content.style.maxHeight = content.scrollHeight + 60 + 'px';
      headerItem.classList.add('header__active-menu-item');
      document.documentElement.classList.add('mega_menu_overlay'); // html instead of body
    }
    function closeMenu() {
      // Remove active state
      menu.classList.remove('active_mega_menu');
      content.style.maxHeight = '0px';
      headerItem.classList.remove('header__active-menu-item');
      document.documentElement.classList.remove('mega_menu_overlay'); // html instead of body
    }
    let isHovered = false;
    headerItem.addEventListener('mouseenter', () => {
      isHovered = true;
      openMenu();
    });
    content.addEventListener('mouseenter', () => {
      isHovered = true;
    });
    headerItem.addEventListener('mouseleave', () => {
      isHovered = false;
      setTimeout(() => {
        if (!menu.matches(':hover')) {
          closeMenu();
        }
      }, 100);
    });
    content.addEventListener('mouseleave', () => {
      isHovered = false;
      setTimeout(() => {
        if (!menu.matches(':hover')) {
          closeMenu();
        }
      }, 100);
    });
  });
});

document.querySelectorAll('.header__menu-item').forEach(item => {
  item.addEventListener('mouseenter', () => {
    const sectionHeader = document.querySelector('.section-header');
    if (sectionHeader.classList.contains('shopify-section-header-hidden')) {
      sectionHeader.classList.remove('shopify-section-header-hidden');
    }
    const observer = new MutationObserver(() => {
      if (sectionHeader.classList.contains('shopify-section-header-hidden')) {
        sectionHeader.classList.remove('shopify-section-header-hidden');
      }
    });
    observer.observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
    item.addEventListener('mouseleave', () => {
      observer.disconnect(); // cleanup
    }, { once: true });
  });
});


// ==================================== Hero Banner Js

const swiperhero = new Swiper('.hero_banner_blocks', {
  loop: true,

  pagination: {
    el: '.slider__pagination',
    clickable: true,
  },
});

// =================================== Heading Aniamtion Js

document.addEventListener("DOMContentLoaded", function () {
  const mainDivHeads = document.querySelectorAll('.main_div_head');
  mainDivHeads.forEach(mainDiv => {
    const contentElement = mainDiv.querySelector('.coman_content');
    function applyAnimation() {
        if (mainDiv.classList.contains('active')) {
            const text = contentElement.innerHTML;
            const words = text.split(' ').map((word, index) => {
                return `<span class="fade-inn" style="animation-delay: ${0.2 + index * 0.3}s;">${word}</span>`;
            }).join(' ');

            contentElement.innerHTML = words;
        } else {
            contentElement.innerHTML = contentElement.textContent; // Restore original text
        }
    }
    applyAnimation();
  });
});

document.addEventListener("DOMContentLoaded", function () {
    const mainDivHeads = document.querySelectorAll('.main_div_head');
    mainDivHeads.forEach(mainDiv => {
        const contentElement = mainDiv.querySelector('.coman_content');
        const svgIcon = `<svg width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.2122 8.67184C5.14403 8.66936 5.07911 8.64189 5.02965 8.5946C4.98019 8.54731 4.94961 8.48346 4.94365 8.41506C4.93132 8.34409 4.94462 8.27101 4.98115 8.20905C5.01768 8.14708 5.07503 8.10031 5.14283 8.0772L6.38936 7.71005C4.48711 7.73032 4.42445 7.665 4.34836 7.58391C4.29446 7.52146 4.26502 7.44138 4.26555 7.35867C4.26555 7.1154 4.26555 6.88115 7.20621 6.3721C6.59973 6.42841 5.97758 6.50724 5.58147 6.5568C4.29465 6.72348 4.12233 6.73474 3.9791 6.59058C3.92003 6.53014 3.885 6.45001 3.88063 6.36534C3.87988 6.31514 3.89131 6.26551 3.91393 6.22077C3.93655 6.17602 3.96967 6.13751 4.01043 6.10856C3.78887 6.07553 3.57977 5.98467 3.40395 5.84503C3.334 5.78496 3.27779 5.71038 3.23917 5.6264C3.20054 5.54243 3.18041 5.45104 3.18015 5.3585C3.17585 5.28214 3.20163 5.20716 3.25191 5.14981C3.30218 5.09246 3.37289 5.05738 3.4487 5.05217C4.56768 4.94855 5.73141 4.82692 6.7452 4.68727C3.54046 4.72106 3.48227 4.65574 3.38828 4.56339C3.33306 4.50173 3.30342 4.42112 3.30547 4.33814C3.30547 3.99126 3.54494 3.77503 3.97686 3.63313H3.83363C3.75982 3.6302 3.69004 3.59847 3.63907 3.54465C3.58811 3.49083 3.55996 3.41916 3.5606 3.34481C3.55477 3.27029 3.57749 3.19634 3.62409 3.13812C3.6707 3.07991 3.73766 3.04184 3.81125 3.03172C4.95932 2.93262 6.19914 2.78396 7.16817 2.62854H3.71054C3.64209 2.62322 3.57787 2.59315 3.52974 2.54388C3.48161 2.49461 3.45282 2.42947 3.4487 2.3605C3.44018 2.28851 3.45828 2.21589 3.49956 2.15649C3.54084 2.09708 3.6024 2.05504 3.6725 2.0384L4.97722 1.78838C4.41997 1.77711 4.1738 1.71405 4.05519 1.59016C3.98821 1.51999 3.95125 1.42618 3.95224 1.32888C3.95224 1.13967 3.95224 0.896409 5.54118 0.484212C5.51331 0.435584 5.49865 0.380428 5.49866 0.324288C5.49866 0.157608 7.68513 0.0224609 7.68513 0.0224609C7.75644 0.0252767 7.82404 0.0551996 7.87429 0.106196C7.92454 0.157192 7.95371 0.225469 7.95593 0.297259C7.96453 0.369521 7.9465 0.44245 7.90526 0.502229C7.86401 0.562008 7.80241 0.604484 7.73213 0.621611C6.87276 0.786039 5.92611 1.00227 5.27039 1.18697C5.99996 1.18697 6.99808 1.11264 7.59114 1.07435C8.84886 0.988759 8.84887 0.988759 8.963 1.10814C9.01985 1.16909 9.05112 1.24979 9.05028 1.33338C9.05028 1.55863 9.05028 1.61719 6.90409 2.0384H9.20918C9.28497 2.04248 9.35612 2.07644 9.40722 2.13293C9.45832 2.18942 9.48526 2.26389 9.48221 2.34022C9.48221 2.50916 9.4822 2.76368 8.33414 3.04299H9.08385C9.15964 3.04707 9.23079 3.08103 9.28189 3.13752C9.33299 3.19401 9.35993 3.26848 9.35688 3.34481C9.35688 3.87864 8.64969 3.90342 6.9399 3.96198C6.36027 3.98225 8.32295 4.07235 9.83804 4.04983C9.8748 4.04839 9.91142 4.05535 9.94513 4.07017C9.97885 4.08499 10.0088 4.1073 10.0327 4.13542C10.087 4.19753 10.1157 4.27803 10.1133 4.36067C10.1133 4.65348 10.1133 5.01387 4.37521 5.58149C5.23011 5.66258 6.85038 5.52293 8.62731 5.19857L9.2875 5.06793C9.32416 5.06256 9.36152 5.06462 9.39737 5.07401C9.43322 5.0834 9.46684 5.09991 9.49625 5.12259C9.52566 5.14526 9.55026 5.17363 9.5686 5.20602C9.58695 5.23841 9.59866 5.27417 9.60305 5.3112C9.6179 5.3875 9.60292 5.46663 9.56123 5.53209C9.51953 5.59756 9.45435 5.6443 9.37926 5.66258L8.82425 5.77069C9.02697 5.78747 9.2198 5.86604 9.37702 5.99594C9.42598 6.04494 9.46483 6.1032 9.49133 6.16737C9.51783 6.23154 9.53146 6.30035 9.53144 6.36984C9.53387 6.4397 9.51159 6.50816 9.46855 6.56302C9.42552 6.61788 9.36453 6.65559 9.29646 6.66942C8.40128 6.80231 7.45015 6.95998 6.65344 7.11991C7.27335 7.11991 7.96488 7.09964 8.62283 7.08162C8.69162 7.08611 8.75677 7.11433 8.80732 7.1615C8.85786 7.20868 8.89071 7.27195 8.90034 7.34065C8.91105 7.41146 8.89677 7.48382 8.85997 7.54514C8.82317 7.60645 8.76619 7.65285 8.69893 7.67626L7.42777 8.02314C7.76122 8.04566 7.80598 8.09296 7.85074 8.14252C7.90663 8.20408 7.93774 8.28437 7.93802 8.36776C7.93983 8.40563 7.93419 8.44349 7.92144 8.47917C7.90869 8.51484 7.88907 8.54764 7.86371 8.57568C7.83835 8.60371 7.80774 8.62644 7.77364 8.64255C7.73955 8.65867 7.70262 8.66785 7.66499 8.66959C7.62076 8.66913 7.57747 8.65668 7.53967 8.63355C7.29349 8.59976 6.1969 8.63355 5.22339 8.66734H5.2122" fill="#00AFA9"/>
<path d="M17.2368 8.6674C16.2655 8.62235 15.1667 8.59982 14.9205 8.63361C14.8827 8.65674 14.8394 8.66919 14.7952 8.66965C14.7575 8.66792 14.7206 8.65873 14.6865 8.64262C14.6524 8.6265 14.6218 8.60378 14.5965 8.57574C14.5711 8.5477 14.5515 8.51491 14.5387 8.47923C14.526 8.44355 14.5203 8.40569 14.5221 8.36782C14.5224 8.28444 14.5535 8.20414 14.6094 8.14258C14.6542 8.09303 14.6989 8.04572 15.0324 8.0232L13.7769 7.6538C13.7096 7.63039 13.6527 7.58399 13.6159 7.52267C13.5791 7.46136 13.5648 7.389 13.5755 7.31819C13.5851 7.24949 13.618 7.18622 13.6685 7.13904C13.7191 7.09186 13.7842 7.06365 13.853 7.05915C14.511 7.07717 15.1958 7.09069 15.8224 7.09745C15.0257 6.94653 14.0813 6.78886 13.1794 6.64696C13.1134 6.63085 13.055 6.59217 13.0142 6.53753C12.9733 6.48289 12.9526 6.41568 12.9556 6.34738C12.9551 6.27782 12.9685 6.20886 12.995 6.14462C13.0215 6.08038 13.0606 6.02217 13.11 5.97348C13.2672 5.84358 13.4601 5.76501 13.6628 5.74823L13.1078 5.64012C13.0327 5.62184 12.9675 5.57509 12.9258 5.50963C12.8841 5.44417 12.8691 5.36504 12.884 5.28873C12.8884 5.25171 12.9001 5.21595 12.9184 5.18356C12.9368 5.15117 12.9614 5.1228 12.9908 5.10012C13.0202 5.07745 13.0538 5.06094 13.0897 5.05155C13.1255 5.04216 13.1629 5.0401 13.1995 5.04547L13.8709 5.17611C15.6456 5.50046 17.2659 5.64012 18.123 5.55903C12.3849 4.98916 12.3849 4.63102 12.3849 4.3382C12.3825 4.25557 12.4113 4.17507 12.4655 4.11296C12.4893 4.08471 12.5192 4.06231 12.553 4.04748C12.5867 4.03264 12.6234 4.02576 12.6602 4.02737C14.1775 4.05214 16.1379 3.95754 15.5695 3.93952C13.8575 3.88096 13.1503 3.85618 13.1503 3.32235C13.1472 3.24602 13.1742 3.17155 13.2253 3.11506C13.2764 3.05857 13.3475 3.02461 13.4233 3.02053H14.1753C13.025 2.74122 13.025 2.4867 13.025 2.31776C13.0219 2.24143 13.0489 2.16696 13.1 2.11047C13.1511 2.05398 13.2222 2.02002 13.298 2.01594H15.6031C13.4569 1.59473 13.4569 1.53617 13.4569 1.31092C13.4561 1.22732 13.4873 1.14663 13.5442 1.08568C13.6583 0.966298 13.6583 0.966298 14.916 1.05189C15.5091 1.09018 16.5072 1.15776 17.2368 1.16451C16.5654 0.979813 15.6277 0.763578 14.775 0.59915C14.7048 0.582023 14.6432 0.539547 14.6019 0.479768C14.5607 0.419989 14.5426 0.34706 14.5512 0.274798C14.5535 0.203008 14.5826 0.134731 14.6329 0.0837347C14.6831 0.0327384 14.7507 0.00281572 14.822 0C14.822 0 17.0085 0.135147 17.0085 0.301827C17.0085 0.357967 16.9939 0.413123 16.966 0.461751C18.5549 0.873948 18.5549 1.11721 18.5549 1.30642C18.5559 1.40372 18.519 1.49753 18.452 1.5677C18.3334 1.69158 18.0872 1.75465 17.5299 1.76591L18.8347 2.01594C18.9043 2.03346 18.9653 2.0757 19.0064 2.13488C19.0475 2.19407 19.066 2.26621 19.0585 2.33804C19.0563 2.41042 19.0268 2.47927 18.9762 2.53069C18.9255 2.58211 18.8573 2.61227 18.7854 2.61509H15.2763C16.2566 2.7705 17.4964 2.91917 18.6333 3.01827C18.6724 3.02239 18.7104 3.03447 18.7448 3.05377C18.7792 3.07308 18.8093 3.09922 18.8334 3.1306C18.8574 3.16198 18.8749 3.19795 18.8847 3.23633C18.8946 3.27471 18.8966 3.31471 18.8906 3.35389C18.8913 3.42823 18.8631 3.49991 18.8121 3.55372C18.7612 3.60754 18.6914 3.63928 18.6176 3.6422H18.4744C18.9219 3.7841 19.1457 4.00034 19.1457 4.34721C19.1474 4.3884 19.1409 4.42949 19.1267 4.46814C19.1124 4.5068 19.0908 4.54225 19.0629 4.57246C18.9801 4.66481 18.922 4.72788 15.7172 4.69634C16.7332 4.82924 17.897 4.95763 19.0137 5.06124C19.0847 5.07124 19.1494 5.10745 19.1953 5.16281C19.2412 5.21818 19.265 5.28876 19.2621 5.36081C19.2619 5.45335 19.2417 5.54474 19.2031 5.62872C19.1645 5.71269 19.1083 5.78727 19.0383 5.84734C18.8648 5.98198 18.6598 6.06961 18.443 6.10187C18.4838 6.13081 18.5169 6.16933 18.5395 6.21407C18.5622 6.25882 18.5736 6.30845 18.5728 6.35864C18.5685 6.44332 18.5334 6.52344 18.4744 6.58389C18.3311 6.72805 18.1588 6.71453 16.872 6.5501C16.4759 6.50055 15.8537 6.42171 15.2472 6.3654C18.1879 6.87445 18.1879 7.10871 18.1879 7.35197C18.1895 7.43488 18.1599 7.51533 18.1051 7.57722C18.029 7.6583 17.9686 7.72363 16.0663 7.70335L17.3241 8.07726C17.3916 8.10077 17.4487 8.14761 17.4851 8.20947C17.5216 8.27133 17.5351 8.3442 17.5232 8.41513C17.5168 8.48372 17.4857 8.54759 17.4359 8.59484C17.3861 8.64209 17.3209 8.66948 17.2524 8.6719" fill="#00AFA9"/>
<path d="M0.25022 20.9364C0.0264257 19.7538 -0.0765202 16.695 0.0644703 16.0688C0.485204 14.2939 2.11891 13.4808 3.75261 13.4808C6.46276 13.4808 6.58137 15.1814 6.58137 16.5824C6.58137 16.5824 6.59703 18.7988 6.6306 19.22C6.87678 22.2766 8.79022 23.815 11.7443 23.815C14.5932 23.815 16.8155 22.2631 16.8155 19.1592C16.8155 16.722 16.6857 17.1635 16.6857 16.3121C16.6857 13.9853 17.5361 13.1091 19.3578 13.1091C21.2265 13.1091 22.7662 14.107 23.1399 16.2626C23.2809 17.1861 23.2809 19.9475 23.2339 20.612C22.8132 25.6372 18.5163 28.8897 11.4646 28.8897C4.50679 28.8897 1.14316 25.7859 0.254697 20.9454" fill="#0F0F0F"/>
<path d="M23.0193 17.184C21.9474 16.5398 20.8799 19.1323 19.8459 18.4318C18.812 17.7313 17.7825 15.8888 16.6904 15.2649C16.7173 18.585 16.8404 22.8894 17.0284 25.009C17.1043 25.9337 17.5212 26.7963 18.197 27.4274C18.8729 28.0584 19.7588 28.4122 20.6807 28.4192C22.0525 28.4192 23.3394 27.4686 23.3394 25.3536V23.2813C23.2543 22.4817 23.2834 17.8957 23.0261 17.184" fill="#0F0F0F"/>
</svg>`;
        const logoSvgIcon = `<svg class="logo_in" width="236" height="64" viewBox="0 0 236 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2042_2635)">
<path d="M44.7169 17.6164C44.6078 17.6124 44.5039 17.5684 44.4248 17.4928C44.3457 17.4171 44.2967 17.3149 44.2872 17.2055C44.2675 17.0919 44.2887 16.975 44.3472 16.8759C44.4056 16.7767 44.4974 16.7019 44.6059 16.6649L46.6003 16.0775C43.5567 16.1099 43.4565 16.0054 43.3347 15.8757C43.2485 15.7757 43.2014 15.6476 43.2022 15.5153C43.2022 15.126 43.2022 14.7512 47.9073 13.9368C46.9369 14.0269 45.9415 14.153 45.3077 14.2323C43.2488 14.499 42.9731 14.517 42.7439 14.2863C42.6494 14.1896 42.5933 14.0614 42.5863 13.9259C42.5851 13.8456 42.6034 13.7662 42.6396 13.6946C42.6758 13.623 42.7288 13.5614 42.794 13.5151C42.4395 13.4623 42.105 13.3169 41.8237 13.0934C41.7118 12.9973 41.6218 12.878 41.56 12.7436C41.4982 12.6093 41.466 12.4631 41.4656 12.315C41.4587 12.1928 41.5 12.0729 41.5804 11.9811C41.6608 11.8893 41.774 11.8332 41.8953 11.8249C43.6856 11.6591 45.5476 11.4645 47.1697 11.241C42.0421 11.2951 41.949 11.1906 41.7986 11.0428C41.7102 10.9442 41.6628 10.8152 41.6661 10.6824C41.6661 10.1274 42.0492 9.78145 42.7403 9.55441H42.5112C42.3931 9.54973 42.2814 9.49896 42.1999 9.41285C42.1183 9.32674 42.0733 9.21206 42.0743 9.09311C42.065 8.97386 42.1013 8.85555 42.1759 8.76241C42.2505 8.66927 42.3576 8.60836 42.4753 8.59216C44.3123 8.43359 46.296 8.19573 47.8464 7.94707H42.3142C42.2047 7.93856 42.1019 7.89044 42.0249 7.81161C41.9479 7.73278 41.9019 7.62856 41.8953 7.5182C41.8816 7.40303 41.9106 7.28683 41.9766 7.19178C42.0427 7.09673 42.1412 7.02947 42.2533 7.00284L44.3409 6.60281C43.4493 6.58479 43.0554 6.48388 42.8656 6.28566C42.7585 6.17339 42.6993 6.02329 42.7009 5.86761C42.7009 5.56488 42.7009 5.17566 45.2432 4.51614C45.1986 4.43834 45.1752 4.35009 45.1752 4.26027C45.1752 3.99358 48.6736 3.77734 48.6736 3.77734C48.7876 3.78185 48.8958 3.82973 48.9762 3.91132C49.0566 3.99291 49.1033 4.10216 49.1068 4.21702C49.1206 4.33264 49.0917 4.44933 49.0258 4.54497C48.9598 4.64062 48.8612 4.70858 48.7488 4.73598C47.3738 4.99907 45.8591 5.34504 44.81 5.64056C45.9773 5.64056 47.5743 5.52164 48.5232 5.46037C50.5355 5.32342 50.5355 5.32342 50.7181 5.51443C50.8091 5.61196 50.8591 5.74106 50.8578 5.87482C50.8578 6.23521 50.8578 6.32891 47.4239 7.00284H51.112C51.2333 7.00938 51.3471 7.06371 51.4289 7.1541C51.5106 7.24448 51.5538 7.36363 51.5489 7.48577C51.5489 7.75606 51.5489 8.1633 49.712 8.61018H50.9115C51.0328 8.61672 51.1466 8.67106 51.2284 8.76144C51.3101 8.85182 51.3532 8.97098 51.3483 9.09311C51.3483 9.94723 50.2168 9.98688 47.4812 10.0806C46.5538 10.113 49.6941 10.2572 52.1182 10.2211C52.177 10.2188 52.2356 10.23 52.2896 10.2537C52.3435 10.2774 52.3914 10.3131 52.4297 10.3581C52.5165 10.4575 52.5625 10.5862 52.5586 10.7185C52.5586 11.187 52.5586 11.7636 43.3777 12.6718C44.7455 12.8015 47.338 12.5781 50.181 12.0591L51.2373 11.8501C51.296 11.8415 51.3558 11.8448 51.4131 11.8598C51.4705 11.8748 51.5243 11.9013 51.5713 11.9375C51.6184 11.9738 51.6578 12.0192 51.6871 12.071C51.7165 12.1229 51.7352 12.1801 51.7422 12.2393C51.766 12.3614 51.742 12.488 51.6753 12.5928C51.6086 12.6975 51.5043 12.7723 51.3842 12.8015L50.4961 12.9745C50.8205 13.0014 51.129 13.1271 51.3806 13.3349C51.4589 13.4133 51.5211 13.5065 51.5635 13.6092C51.6059 13.7119 51.6277 13.822 51.6276 13.9332C51.6315 14.0449 51.5959 14.1545 51.527 14.2422C51.4582 14.33 51.3606 14.3903 51.2517 14.4125C49.8194 14.6251 48.2976 14.8774 47.0229 15.1333C48.0147 15.1333 49.1211 15.1008 50.1739 15.072C50.2839 15.0792 50.3882 15.1243 50.469 15.1998C50.5499 15.2753 50.6025 15.3765 50.6179 15.4864C50.635 15.5997 50.6122 15.7155 50.5533 15.8136C50.4944 15.9117 50.4032 15.986 50.2956 16.0234L48.2618 16.5784C48.7953 16.6145 48.8669 16.6901 48.9385 16.7694C49.0279 16.8679 49.0777 16.9964 49.0782 17.1298C49.0811 17.1904 49.0721 17.251 49.0517 17.3081C49.0312 17.3652 48.9999 17.4176 48.9593 17.4625C48.9187 17.5073 48.8697 17.5437 48.8152 17.5695C48.7606 17.5953 48.7015 17.61 48.6413 17.6127C48.5706 17.612 48.5013 17.5921 48.4408 17.5551C48.0469 17.501 46.2924 17.5551 44.7348 17.6091H44.7169" fill="#0F0F0F"/>
<path d="M63.9546 17.609C62.4006 17.537 60.6425 17.5009 60.2486 17.555C60.1881 17.592 60.1188 17.6119 60.0481 17.6127C59.9879 17.6099 59.9288 17.5952 59.8742 17.5694C59.8197 17.5436 59.7707 17.5073 59.7301 17.4624C59.6895 17.4175 59.6582 17.3651 59.6377 17.308C59.6173 17.2509 59.6083 17.1903 59.6112 17.1297C59.6117 16.9963 59.6614 16.8678 59.7509 16.7693C59.8225 16.6901 59.8941 16.6144 60.4276 16.5783L58.4188 15.9873C58.3112 15.9498 58.22 15.8756 58.1612 15.7775C58.1023 15.6794 58.0794 15.5636 58.0966 15.4503C58.112 15.3404 58.1645 15.2392 58.2454 15.1637C58.3263 15.0882 58.4305 15.0431 58.5406 15.0359C59.5933 15.0647 60.689 15.0863 61.6916 15.0971C60.4169 14.8557 58.9058 14.6034 57.4628 14.3763C57.3572 14.3506 57.2637 14.2887 57.1984 14.2013C57.1331 14.1138 57.1 14.0063 57.1047 13.897C57.1039 13.7857 57.1253 13.6754 57.1678 13.5726C57.2102 13.4698 57.2728 13.3767 57.3518 13.2988C57.6033 13.0909 57.9119 12.9652 58.2362 12.9384L57.3482 12.7654C57.2281 12.7361 57.1238 12.6614 57.0571 12.5566C56.9904 12.4519 56.9664 12.3253 56.9901 12.2032C56.9972 12.144 57.0159 12.0867 57.0453 12.0349C57.0746 11.9831 57.114 11.9377 57.161 11.9014C57.2081 11.8651 57.2619 11.8387 57.3192 11.8237C57.3766 11.8087 57.4364 11.8054 57.495 11.814L58.5692 12.023C61.4087 12.542 64.0012 12.7654 65.3726 12.6357C56.1916 11.7239 56.1916 11.1508 56.1916 10.6823C56.1877 10.5501 56.2338 10.4213 56.3205 10.3219C56.3587 10.2767 56.4066 10.2409 56.4605 10.2172C56.5145 10.1934 56.5732 10.1824 56.6321 10.185C59.0598 10.2246 62.1965 10.0733 61.287 10.0444C58.5477 9.95075 57.4162 9.9111 57.4162 9.05697C57.4114 8.93484 57.4545 8.81569 57.5362 8.72531C57.618 8.63493 57.7318 8.58059 57.8531 8.57405H59.0562C57.2157 8.12717 57.2157 7.71993 57.2157 7.44963C57.2108 7.3275 57.2539 7.20835 57.3357 7.11796C57.4175 7.02758 57.5313 6.97324 57.6526 6.96671H61.3407C57.9068 6.29278 57.9068 6.19908 57.9068 5.83869C57.9055 5.70493 57.9555 5.57582 58.0464 5.47829C58.2291 5.28729 58.2291 5.28729 60.2414 5.42424C61.1903 5.4855 62.7873 5.59362 63.9546 5.60443C62.8804 5.30891 61.3801 4.96294 60.0158 4.69985C59.9034 4.67245 59.8048 4.60449 59.7388 4.50884C59.6728 4.41319 59.644 4.29651 59.6578 4.18089C59.6613 4.06602 59.708 3.95678 59.7884 3.87519C59.8688 3.79359 59.9769 3.74572 60.091 3.74121C60.091 3.74121 63.5894 3.95745 63.5894 4.22413C63.5894 4.31396 63.566 4.40221 63.5214 4.48001C66.0637 5.13953 66.0637 5.52875 66.0637 5.83148C66.0653 5.98716 66.0061 6.13725 65.8989 6.24953C65.7092 6.44775 65.3153 6.54866 64.4237 6.56667L66.5113 6.96671C66.6226 6.99474 66.7202 7.06233 66.786 7.15702C66.8518 7.25172 66.8814 7.36715 66.8693 7.48207C66.8658 7.59789 66.8187 7.70805 66.7377 7.79032C66.6566 7.87258 66.5475 7.92084 66.4325 7.92535H60.8179C62.3863 8.17402 64.37 8.41188 66.189 8.57045C66.2517 8.57703 66.3124 8.59636 66.3674 8.62725C66.4224 8.65814 66.4707 8.69996 66.5092 8.75017C66.5477 8.80038 66.5756 8.85793 66.5914 8.91934C66.6071 8.98075 66.6103 9.04474 66.6008 9.10743C66.6018 9.22638 66.5568 9.34106 66.4752 9.42717C66.3937 9.51328 66.282 9.56405 66.1639 9.56873H65.9348C66.6509 9.79578 67.009 10.1418 67.009 10.6968C67.0115 10.7626 67.0012 10.8284 66.9784 10.8902C66.9557 10.9521 66.9211 11.0088 66.8765 11.0571C66.744 11.2049 66.6509 11.3058 61.5233 11.2554C63.149 11.468 65.0109 11.6734 66.7977 11.8392C66.9112 11.8552 67.0148 11.9131 67.0883 12.0017C67.1617 12.0903 67.1998 12.2032 67.1952 12.3185C67.1948 12.4666 67.1625 12.6128 67.1007 12.7472C67.0389 12.8815 66.949 13.0008 66.8371 13.097C66.5594 13.3124 66.2315 13.4526 65.8846 13.5042C65.9498 13.5505 66.0028 13.6121 66.039 13.6837C66.0752 13.7553 66.0935 13.8347 66.0923 13.915C66.0853 14.0505 66.0293 14.1787 65.9348 14.2754C65.7056 14.5061 65.4299 14.4845 63.371 14.2214C62.7372 14.1421 61.7417 14.016 60.7714 13.9259C65.4764 14.7403 65.4764 15.1151 65.4764 15.5044C65.479 15.637 65.4317 15.7657 65.3439 15.8648C65.2222 15.9945 65.1255 16.099 62.0819 16.0666L64.0943 16.6648C64.2023 16.7024 64.2936 16.7774 64.352 16.8764C64.4103 16.9753 64.4319 17.0919 64.413 17.2054C64.4026 17.3152 64.3529 17.4174 64.2732 17.493C64.1935 17.5686 64.0891 17.6124 63.9797 17.6163" fill="#0F0F0F"/>
<path d="M33.4224 34.8102C33.4224 38.6087 33.2147 42.8937 32.5952 46.0688C32.0474 48.9014 29.6447 50.2853 27.2456 50.2853C24.775 50.2853 22.3723 48.696 22.3723 45.312C22.3723 42.4793 22.8521 38.1258 22.8521 32.6694C22.8521 27.1446 21.1369 24.0201 17.2268 24.0201C12.9013 24.0201 10.6383 26.9897 10.6383 32.5145C10.6383 34.6552 10.7063 42.3928 10.7063 46.6742C10.7063 49.7123 8.37171 51.3593 5.76495 51.3593C3.22622 51.3593 0.547849 49.633 0.411782 45.903C0.0680335 40.9584 0 29.2169 0 18.0952C0 12.7795 0 8.15205 0.275715 4.97341C0.55143 1.79476 3.22264 0.136963 5.69691 0.136963C8.02796 0.136963 10.4306 1.65781 10.6383 4.76798V11.4676C10.6383 13.7453 10.5667 16.578 10.5667 18.9926C12.6972 16.7149 15.7157 15.1941 19.9696 15.1941C28.5633 15.1941 32.8029 21.1369 33.2827 29.7683C33.3508 31.2099 33.4224 32.9469 33.4224 34.8138" fill="#00AFA9"/>
<path d="M104.02 32.1186C104.02 26.9398 100.726 23.9665 95.8525 23.9665C91.2548 23.9665 87.8925 27.0767 87.8925 32.187C87.8925 37.2325 91.2548 40.267 95.7164 40.267C100.038 40.267 104.02 37.2974 104.02 32.1186ZM114.583 33.3619C114.583 37.9893 114.447 42.7537 114.171 45.8639C113.556 55.1872 107.859 63.8222 93.5143 63.8222C87.3411 63.8222 80.2656 61.8869 80.2656 57.191C80.2656 54.8412 82.056 52.841 85.0674 52.841C87.9498 52.841 89.597 55.0502 94.8821 55.0502C100.715 55.0502 103.941 51.5977 103.941 46.7612V43.6547C101.263 46.8982 96.6653 48.21 92.8912 48.21C83.5563 48.21 77.1074 41.9933 77.1074 32.8105C77.1074 22.5178 84.3118 15.7496 93.8508 15.7496C97.6249 15.7496 101.675 17.1912 103.941 20.0311V16.7155C103.941 13.3314 106 11.8105 108.195 11.8105C109.668 11.8252 111.082 12.3927 112.161 13.402C113.24 14.4112 113.906 15.7895 114.028 17.2669C114.386 21.1375 114.576 27.2821 114.576 33.3619" fill="#00AFA9"/>
<path d="M145.263 32.1186C145.263 26.9398 141.969 23.9665 137.099 23.9665C132.498 23.9665 129.136 27.0767 129.136 32.187C129.136 37.2325 132.498 40.267 136.96 40.267C141.285 40.267 145.263 37.2974 145.263 32.1186ZM155.833 33.3619C155.833 37.9893 155.697 42.7537 155.422 45.8639C154.802 55.1872 149.109 63.8222 134.765 63.8222C128.588 63.8222 121.516 61.8869 121.516 57.191C121.516 54.8412 123.306 52.841 126.321 52.841C129.186 52.841 130.851 55.0502 136.132 55.0502C141.965 55.0502 145.192 51.5977 145.192 46.7612V43.6547C142.517 46.8982 137.919 48.21 134.145 48.21C124.81 48.21 118.361 41.9933 118.361 32.8105C118.361 22.5178 125.566 15.7496 135.105 15.7496C138.879 15.7496 142.929 17.1912 145.192 20.0311V16.7155C145.192 13.3314 147.251 11.8105 149.445 11.8105C150.919 11.8243 152.334 12.3914 153.414 13.4008C154.494 14.4101 155.16 15.7889 155.282 17.2669C155.622 21.1375 155.83 27.2821 155.83 33.3619" fill="#00AFA9"/>
<path d="M159.578 45.7949C159.371 42.3423 159.303 37.4374 159.303 32.3235C159.303 21.6883 159.51 8.35746 159.922 4.35352C160.262 1.3803 162.805 0 165.204 0C167.402 0 169.597 1.24335 169.805 3.66157C170.009 6.00771 170.077 12.156 170.077 19.2016C170.077 28.4565 170.009 39.3835 169.805 45.5858C169.733 49.042 167.195 50.6962 164.724 50.6962C162.253 50.6962 159.783 49.1105 159.578 45.7949Z" fill="#00AFA9"/>
<path d="M184.008 28.8025L198.489 28.5934C198.213 24.5895 195.266 22.1713 191.685 22.1713C187.707 22.1713 184.961 24.521 184.001 28.8025M195.606 34.7417C191.693 34.7417 187.013 34.6732 183.733 34.6732C184.488 40.335 188.33 42.6847 193.136 42.6847C198.625 42.6847 200.136 40.198 202.804 40.198C204.862 40.198 206.237 41.9243 206.237 43.8596C206.237 48.4185 199.434 51.3882 192.631 51.3882C181.305 51.3882 173.295 44.62 173.295 33.3686C173.295 21.5586 181.667 14.167 191.961 14.167C200.677 14.167 208.074 20.1062 208.074 28.4637C208.074 33.3001 205.604 34.475 202.585 34.612C201.074 34.6804 198.467 34.7489 195.585 34.7489" fill="#00AFA9"/>
<path d="M235.683 21.4106C235.683 24.0378 233.893 26.73 230.538 26.73C229.303 26.73 228.275 26.4525 227.108 26.4525C223.402 26.4525 222.453 29.4221 222.453 33.4981C222.453 37.8516 222.589 45.1712 222.589 46.9659C222.589 49.9355 220.05 51.5969 217.443 51.5969C215.109 51.5969 212.842 50.2815 212.362 47.5894C212.004 46.0685 211.814 38.4715 211.814 31.4258C211.814 26.1065 211.951 20.9277 212.226 18.5779C212.774 14.574 215.589 12.6387 218.127 12.6387C220.254 12.6387 222.177 14.0802 222.177 16.9922C222.177 17.8896 222.177 19.0644 222.109 20.2357C223.051 19.0179 224.259 18.0354 225.639 17.3646C227.02 16.6939 228.536 16.3531 230.069 16.3687C233.979 16.3687 235.694 18.9239 235.694 21.4142" fill="#00AFA9"/>
<path d="M36.7773 37.2394C36.4192 35.3474 36.2545 30.4532 36.4801 29.4514C37.1533 26.6115 39.7672 25.3105 42.3811 25.3105C46.7174 25.3105 46.9071 28.0314 46.9071 30.273C46.9071 30.273 46.9322 33.8193 46.9859 34.4932C47.3798 39.3837 50.4413 41.8452 55.1678 41.8452C59.7261 41.8452 63.2817 39.3621 63.2817 34.3959C63.2817 30.4965 63.0741 31.2029 63.0741 29.8406C63.0741 26.1177 64.4347 24.7158 67.3494 24.7158C70.3393 24.7158 72.8029 26.3124 73.4008 29.7613C73.6264 31.2389 73.6264 35.6573 73.5512 36.7204C72.8781 44.7608 66.0031 49.9648 54.7203 49.9648C43.5878 49.9648 38.206 44.9986 36.7845 37.2538" fill="#00AFA9"/>
<path d="M73.2083 31.2346C71.4931 30.2039 69.7851 34.352 68.1308 33.2312C66.4765 32.1103 64.8294 29.1623 63.082 28.1641C63.125 33.4762 63.3219 40.3633 63.6227 43.7546C63.7443 45.2341 64.4113 46.6144 65.4926 47.624C66.574 48.6337 67.9915 49.1997 69.4664 49.2109C71.6614 49.2109 73.7203 47.69 73.7203 44.306V40.9904C73.5843 39.711 73.6308 32.3734 73.219 31.2346" fill="#00AFA9"/>
</g>
<defs>
<clipPath id="clip0_2042_2635">
<rect width="236" height="64" fill="white"/>
</clipPath>
</defs>
</svg>
`;
    const text = contentElement.innerHTML;
    const wrappedText = text
      .replace(/(U)/g, `<div class="highlight">U</div>`) // Wrap "U" in a div
      .replace(/(u)/g, `<div class="highlight">${svgIcon}</div>`) // Replace "u" with the SVG inside a div
      .replace(/logo/g, logoSvgIcon); // Replace "logo" with logoSvgIcon
    contentElement.innerHTML = wrappedText;
  });
});

// ==============================  Featured Collection Css

 var swiperfeaturedcoll = new Swiper(".featured_collection_block", {
  spaceBetween: 24,
  slidesPerView: 4.2,
  slidesOffsetAfter: 80,
  breakpoints: {
    320: {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 10,
      loop: true,
      speed:500,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
    },
    576: {
      slidesPerView: 1.3,
      centeredSlides: true,
      loop: false,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
    },
    768: {
      slidesPerView: 2.2,
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
    992: {
      slidesPerView: 2.3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".featured_coll_products .swiper-button-next",
        prevEl: ".featured_coll_products .swiper-button-prev",
      },
      scrollbar: {
        el: ".featured_collection_block .swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    },
    1024: {
      slidesPerView: 3.15,
      spaceBetween: 24,
      loop: false,
      slidesOffsetAfter: 0,
      navigation: {
        nextEl: ".featured_coll_products .swiper-button-next",
        prevEl: ".featured_coll_products .swiper-button-prev",
      },
      scrollbar: {
        el: ".featured_collection_block .swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    },
    1440: {
      slidesPerView: 4.2,
      spaceBetween: 24,
      loop: false,
      navigation: {
        nextEl: ".featured_coll_products .swiper-button-next",
        prevEl: ".featured_coll_products .swiper-button-prev",
      },
      scrollbar: {
        el: ".featured_collection_block .swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    },
  },
});

//=======================================Service Js

var serviceSwiper = new Swiper(".service_inner", {
  slidesPerView: 1.5,
  spaceBetween: 16,
  centeredSlides: true,
  loop: true,
  centeredSlidesBounds: true,
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 24,
      centeredSlides: true,
      loop: true,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 24,
      centeredSlides: false,
      centeredSlidesBounds: false,
    },
  },
});

// ========================= Collection Tabify Js

collections_tabify_product_wrapper = new Swiper(".collections_tabify_product_wrapper", {
  slidesPerView: 1.5,
  spaceBetween: 20,
  breakpoints: {
    320: {
      slidesPerView: 1.3,
      spaceBetween: 20,
      slidesOffsetAfter: 0,
      loop: true,
      centeredSlides: true,
      freeMode: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
    },
    576: {
      slidesPerView: 1.3,
      spaceBetween: 20,
      loop: true,
      freeMode: false,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 20,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      loop: true,
    },
    992: {
      slidesPerView: 1.8,
      loop: false,
      slidesOffsetAfter: 80,
      navigation: {
        nextEl: ".product_tab_details .swiper-button-next",
        prevEl: ".product_tab_details .swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    },
    1025: {
      slidesPerView: 2.28,
      spaceBetween: 24,
      loop: false,
      slidesOffsetAfter:80,
      navigation: {
        nextEl: ".product_tab_details .swiper-button-next",
        prevEl: ".product_tab_details .swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    },
    1441: {
      slidesPerView: 3.3,
      spaceBetween: 24,
      loop: false,
      slidesOffsetAfter: 80,
      navigation: {
        nextEl: ".product_tab_details .swiper-button-next",
        prevEl: ".product_tab_details .swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all tab headers and content sections
  const tabHeadersUpdated = document.querySelectorAll(
    ".collections_tabify__titleeeee"
  );
  const tabContents = document.querySelectorAll(".product_tab_details");

  // Function to handle tab switching
  function switchTab(event) {
    const targetId = event.target.getAttribute("data-tab-title");

    // Hide all tab contents and remove active class from all tab headers
    tabContents.forEach((content) => content.classList.remove("active"));
    tabHeadersUpdated.forEach((header) => header.classList.remove("active"));

    // Show the clicked tab's content and add active class to clicked tab header
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      targetContent.classList.add("active");
    }
    event.target.classList.add("active");
  }

  // Add click event listeners to all tab headers
  tabHeadersUpdated.forEach((header) =>
    header.addEventListener("click", switchTab)
  );

  // Activate the first tab by default
  if (tabHeadersUpdated.length > 0) {
    tabHeadersUpdated[0].classList.add("active");
    const firstTabId = tabHeadersUpdated[0].getAttribute("data-tab-title");
    const firstTabContent = document.getElementById(firstTabId);
    if (firstTabContent) {
      firstTabContent.classList.add("active");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const tabHeaders = document.querySelectorAll(".collections_tabify__title");
  const tabContents = document.querySelectorAll(".product_tab_details");
  const mobileTitles = document.querySelectorAll(
    ".collections_tabify__main_title.mobile_title"
  );

  function switchTab(event) {
    const header = event.currentTarget;
    const targetId = header.getAttribute("data-tab-title");
    if (!targetId) return;

    console.log("Tab clicked:", targetId); // debug log

    // Hide all contents and deactivate all headers
    tabContents.forEach((content) => content.classList.remove("active"));
    tabHeaders.forEach((h) => h.classList.remove("active"));

    // Show selected content and activate header
    document.getElementById(targetId)?.classList.add("active");
    header.classList.add("active");
  }

  // Attach event listeners to tab headers
  tabHeaders.forEach((header) => {
    header.removeEventListener("click", switchTab); // safety against duplicates
    header.addEventListener("click", switchTab);
  });

  // Activate first tab by default
  if (tabHeaders.length > 0) {
    tabHeaders[0].classList.add("active");
    const firstTabId = tabHeaders[0].getAttribute("data-tab-title");
    document.getElementById(firstTabId)?.classList.add("active");
  }

  // Mobile titles logic
  mobileTitles.forEach(function (title) {
    title.addEventListener("click", function () {
      var tabIndex = this.getAttribute("data-tab-index");

      mobileTitles.forEach((title) => title.classList.remove("active"));
      document
        .querySelectorAll(".product-tab")
        .forEach((tab) => tab.classList.remove("active"));

      this.classList.add("active");
      var correspondingTab = document.querySelector(
        '.product-tab[data-tab-index="' + tabIndex + '"]'
      );
      if (correspondingTab) {
        correspondingTab.classList.add("active");
      }
    });
  });

// Swiper init
  const Swipercolltab = new Swiper(".mob_tab_slider_in", {
    slidesPerView: "auto",
    spaceBetween: 16,
    slideToClickedSlide: true,
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 16,
        centeredSlides: true,
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 16,
        centeredSlides: true,
      },
    },
    on: {
      slideChange: function () {
        var slideCurrentIndex = this.realIndex;
        console.log(slideCurrentIndex, "slideCurrentIndex");
        const temp = document.querySelectorAll(
          ".mob_tabbb .product-tab.active .swiper-slide"
        );
        if (temp[slideCurrentIndex]) {
          const title = temp[slideCurrentIndex]
            .querySelector(".box")
            .getAttribute("data-tab-title");
          document
            .querySelectorAll(".right_collections_tabify .product_tab_details")
            .forEach(function (detail) {
              detail.classList.remove("active");
            });
          document.querySelector(`#${title}`)?.classList.add("active");
        }
      },
    },
  });
});

$(document).ready(function () {
  function handleLayout() {
    if ($(window).width() > 768) {
      // Desktop (Tab functionality)
      $(".featured_collection li").click(function () {
        var tab_id = $(this).attr("data-tab");
        $(".featured_collection li").removeClass("hover_active");
        $(this).addClass("hover_active");
        $(".product_tab_details").removeClass("active").fadeOut('fast');
        $("#" + tab_id).addClass("active");
      });
    } else {
      // Mobile (Accordion functionality)
      $(".featured_collection li")
        .off("click")
        .on("click", function () {
          var tab_id = $(this).attr("data-tab");
          var content = $("#" + tab_id);

          if (content.hasClass("active")) {
            content.slideUp().removeClass("active");
            $(this).removeClass("hover_active");
          } else {
            $(".product_tab_details.active").slideUp().removeClass("active");
            $(".featured_collection li").removeClass("hover_active");
            content.slideDown().addClass("active");
            $(this).addClass("hover_active");
          }
        });
    }
  }

  handleLayout();
});

$(".left_collections_tabify .product-tab").on("click", function () {
  $(".product-tab").removeClass("active");
  $(this).addClass("active");
});

// ======================== Mobile Header Js

$(document).ready(function () {
  $(".mobileMenu-togglee").click(function () {
    event.stopPropagation();
    $("html").toggleClass("overlay_header");
  });
  $(window).on("resize", function () {
    if ($(window).width() >= 1025) {
      if (!$("body").data("click-handlers-added")) {
        $("body").click(function () {
          $("html").removeClass("overlay_header");
          $(".menu-lv-item.has-megamenu").removeClass("header_menu_active");
          $("body").removeClass("mega_header_active");
        });
        $(".menu-lv-item.has-megamenu").click(function (event) {
          event.stopPropagation();
        });
        $("body").data("click-handlers-added", true);
      }
    } else {
      $("body").off("click");
      $(".menu-lv-item.has-megamenu").off("click");
      $("body").data("click-handlers-added", false);
    }
  }).resize();
});

$(document).ready(function () {
  // Handle the click event for menu items with a megamenu
  $(".mobileMenu-togglee").click(function () {
    $("html").toggleClass("header_in");
    $(this).toggleClass("active"); // Fixed 'avtivee' to 'active'
    $(this).find(".main_mobile_drawer_cs").toggleClass("menu__active");

    // Open/close the mobile drawer
    $(".main_mobile_drawer_cs").toggleClass("open"); // Toggle 'open' class to display/hide the drawer

    // Remove 'active' class from elements when the menu is closed
    if (!$(this).hasClass("active")) {
      const mainMenuCs = $(".header-mobile").closest(".main_menu_cs");
      const newSubMain = $(".new_sub_main");

      if (mainMenuCs.length) {
        mainMenuCs.removeClass("active");
      }
      if (newSubMain.length) {
        newSubMain.removeClass("active");
      }
    }
    document.querySelector('.mobile_search_input').addEventListener('click', function() {
       initQuickAddPopupFeature();
      const quickSearchResults = document.querySelector('.quickSearchResultsWrap.is-show[data-quick-trending-products]');
      if (quickSearchResults) {
        quickSearchResults.style.display = 'block';
      }
    });
    document.querySelector('.search_close_btn').addEventListener('click', function() {
      const quickSearchResults = document.querySelector('.quickSearchResultsWrap.is-show[data-quick-trending-products]');
      const predictiveSearchResults = document.querySelector('#predictive-search-results');
      
      if (quickSearchResults) {
        quickSearchResults.style.display = 'none';
      }
      if (predictiveSearchResults) {
        predictiveSearchResults.style.display = 'none';
      }
    });
  });
});

//===================product-cuppon_code

let cuppon_code = new Swiper(".cuppon_code", {
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: ".cuppon_code .swiper-button-next",
    prevEl: ".cuppon_code .swiper-button-prev",
  },
});

// ============================== Product Main Slider Js

function initSliders() {
  if (!$('.main_pro_images').hasClass('slick-initialized')) {
    $('.main_pro_images').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 7L1 7M1 7L7 1M1 7L7 13" stroke="#0F0F0F" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7L13 7M13 7L7 13M13 7L7 0.999999" stroke="#0F0F0F" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      asNavFor: '.main_thub_pro .thumbnail-list',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
          }
        }
      ]
    });
  }

  if (!$('.main_thub_pro .thumbnail-list').hasClass('slick-initialized')) {
    $('.main_thub_pro .thumbnail-list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: '.main_pro_images',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      verticalSwiping: true
    });
  }
}

$(window).on('load resize', function () {
  initSliders();
});

$('[data-fancybox="gallery"]').fancybox({
  buttons: [
    "zoom",
    "close"
  ],
  loop: false,
  protect: true
});

function setThumbnailHeight() {
  const gallery = document.querySelector('.gallery_product_main');
  const thumbnail = document.querySelector('.thumbnail_slider_pro');
  if (gallery && thumbnail) {
    thumbnail.style.height = gallery.offsetHeight + 'px';
  }
}
window.addEventListener('load', setThumbnailHeight);
window.addEventListener('resize', setThumbnailHeight);

// =============================

document.addEventListener("DOMContentLoaded", function () {
  document.querySelector(".cartt-size-btn").addEventListener("click", function () {
    document.querySelector("html").classList.add("active_size_box");
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest(".close_size_box")) {
      document.querySelector("html").classList.remove("active_size_box");
    }
  });
});

// =========================================

// Show size chart
document.querySelector('.productView-sizeChart a').addEventListener('click', function (e) {
  e.preventDefault();
  document.documentElement.classList.add('active_size_chart');
});

// Hide on close button click
document.querySelector('.size_chart_close').addEventListener('click', function (e) {
  e.preventDefault();
  document.documentElement.classList.remove('active_size_chart');
});

// Hide on outside click
document.addEventListener('click', function (e) {
  const sizeChartBlock = document.querySelector('.size_chart_block');
  const sizeChartLink = document.querySelector('.productView-sizeChart a');

  const clickedInside = sizeChartBlock.contains(e.target) || sizeChartLink.contains(e.target);

  if (!clickedInside && document.documentElement.classList.contains('active_size_chart')) {
    document.documentElement.classList.remove('active_size_chart');
  }
});

// ================================

document.addEventListener('DOMContentLoaded', function () {
  const closeButtons = document.querySelectorAll('.halo-sidebar-popup');
  const searchInputs = document.querySelectorAll('.search__input');

  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      searchInputs.forEach(input => {
        input.value = '';
      });
    });
  });
});